import React from 'react';
import './InProgress.css';

/**
 * S2 — in progress (Unit 4 build spec §C3). Deliberately minimal: a calm
 * "still writing" state, no stage names, no check results, no draft. The
 * breathe mark is the existing Editing Room loading pattern — not a new
 * spinner, and not an anxious progress bar.
 */
export default function InProgress({ stalled = false, modelName }) {
  return (
    <div className="er-inprogress" role="status" aria-live="polite">
      <div className="er-inprogress__mark" aria-hidden="true" />
      <div className={`er-inprogress__stage${stalled ? ' er-inprogress__stage--stalled' : ''}`}>
        {stalled
          ? 'This is taking longer than expected — still working'
          : 'Writing your scene…'}
      </div>
      {modelName && <div className="er-inprogress__model">{modelName} is at work.</div>}
    </div>
  );
}
